// Welke velden van een activiteitsformulier krijgt de invuller te zien?
//
// Alleen velden met een type waar het formulier een invulveld voor heeft. Een
// veld dat in de bouwer is aangemaakt maar nog geen type kreeg ('Nieuw veld 8')
// heeft niets om in te vullen; zonder deze poort zag de invuller een kop met
// 'Geen type geselecteerd' (testronde 2026-10-28, B4).
//
// Eén lijst voor het openbare formulier (`EventOpen`) en het formulier in de app
// (`AddEvent`): die twee renderen dezelfde typen.
// AI-CONTEXT: See docs/test-runs/2026-10-28-verzendknop-formulier-op-laptop.md

const RENDERABLE_TYPES = new Set([
    'date',
    'participants',
    'outputs',
    'targetgroups',
    'open',
    'number',
    'scale',
    'multiple-one',
    'multiple-multiple',
])

/**
 * @param {{Type?: string} | null | undefined} field - Een EventFields-doc
 * @returns {boolean} True als het formulier voor dit veld een invulveld heeft.
 */
const isRenderableEventField = (field) => RENDERABLE_TYPES.has(field?.Type)

export default isRenderableEventField
